import { Component, Element } from '@stencil/core';
import { MobileUtility } from '~service/mobile-utility';

@Component({
  tag: 'mama-teaser',
})
export class MamaTeaserGrid {
  protected isMobile: boolean;

  @Element() el: HTMLElement;

  mobileChangedListeners = () => (this.isMobile = MobileUtility.isMobile());

  componentWillLoad() {
    MobileUtility.addMobileChangedListeners(this.mobileChangedListeners);
  }

  componentDidLoad() {
    if (this.getTeaserNumber() > 2 || this.isMobile) {
      this.resisizeHeadline();
    }
  }

  resisizeHeadline() {
    this.el.querySelectorAll('h3').forEach(headline => headline.classList.add('h6'));
  }

  getTeaserNumber() {
    var parent = this.getParent(this.el);
    if (parent) {
      return parent.children.length;
    } else {
      return 0;
    }
  }

  getParent(el: HTMLElement) {
    if (el && !el.classList.contains('teaser-grid') && !el.classList.contains('swiper-wrapper') && !el.classList.contains('container')) {
      return this.getParent(el.parentElement);
    } else {
      return el;
    }
  }

  disconnectedCallback() {
    MobileUtility.removeMobileChangedListeners(this.mobileChangedListeners);
  }
}
